import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Input } from '../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { FormFooter } from '../../../elements/form-footer';
import { FieldError } from "../../../elements/field-error/field-error";

// construccion del objeto yup de validacion del cuestionario
let obligado = {
    email: Yup.string().email('must be email').required('obligatorio'),


};
const validacion = Yup.object().shape(obligado, [['password', 'password']]);

const initialValues = {
    email: '',

};

export const ResponsablesForm = ({
    item,
    close,
    doDelete
}: {
    item?: any;
    close: () => void;
    doDelete?: (item: any) => void;
}) => {
    // console.log('USUARIOS FORM :: EDIT ITEM', item);

    const { t } = useTranslation();
    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);





    const beforeSubmit = (values: any | null) => {

        const after = { ...values }

        return after;
    };

    const onSubmit = async (values: any | null) => {

        const enviaremos = beforeSubmit(values);

        api('/fleet/fleet-managers/create_from_email/', 'POST', enviaremos);


    };

    useEffect(() => {


        if (state.data) {

            if (state.path.includes('create_from_emai')) {

                if (state.method === 'POST') {
                    toast.success(`${t('common.label.success-saved')}`);
                    close();

                }
            }

        }

         if (state.error) {
            if (state.error.error == 'Fleet manager already exists for this user') {
                toast.error(`${t('common.error.already-manager-exist')}`);
            } else if (state.error.error == 'No user found with this email') {
                toast.error(`${t('common.error.no-email-exist')}`);
            } else {
                toast.error('Server Error');
            }
        }
    }, [state]);

    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={validacion}
            validateOnBlur={true}
            onSubmit={onSubmit}
        >
            {({
                values,
                errors,
                touched,
                setFieldValue,
                handleSubmit,
                isSubmitting
            }) => (
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Input
                        label={t('usuario.form.email')}
                        type="email"
                        placeholder={t('usuario.form.email')}
                        name="email"
                        value={values.email}
                        onChange={(value) =>
                            setFieldValue('email', value.email)
                        }
                    />
                    <FieldError touched={touched} errors={errors} field={"email"} />

                    <FormFooter
                        item={item}
                        doDelete={doDelete}
                        doSubmit={handleSubmit}
                        close={close}
                    />
                </form>
            )}
        </Formik>
    );
};
